var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2C1.67578 2 1 2.67578 1 3.5V11.5C1 12.3242 1.67578 13 2.5 13H13.5C14.3242 13 15 12.3242 15 11.5V3.5C15 2.67578 14.3242 2 13.5 2H2.5ZM2.5 3H13.5C13.5352 3 13.5625 3.01172 13.5938 3.01953L8 6.89062L2.40625 3.01953C2.4375 3.01172 2.46484 3 2.5 3ZM2 3.95312L8 8.10938L14 3.95312V11.5C14 11.7812 13.7812 12 13.5 12H2.5C2.21875 12 2 11.7812 2 11.5V3.95312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.d6e38f7b83c7ffe5e68aa03d80c44dcd.svg";
export { ForwardRef as ReactComponent };